import { useQuery } from '@tanstack/react-query';
import { API } from 'api';
import { SECTIONS, DOMAINS, IMPORTANCE } from '@repo/monitoring';

import { apiName, apiBasePath } from 'assets';
import VideoResource from 'types/VideoResource';

export async function getPublishedVideoResources() {
  const response = await API.get(
    apiName,
    `${apiBasePath}/video-resources`,
    {},
    true,
    undefined,
    {
      tags: {
        section: SECTIONS.GUIDES,
        domain: DOMAINS.CONTENT,
        importance: IMPORTANCE.MEDIUM,
      },
      context: {},
    },
  );
  return response?.result;
}

const usePublishedVideoResources = () => {
  const videoResourcesQuery = useQuery<VideoResource[]>({
    queryKey: [apiName, `publishedVideoResources`],
    queryFn: () => getPublishedVideoResources(),
    // options...
  });

  return videoResourcesQuery;
};

export default usePublishedVideoResources;
